import axios from 'axios'

export const API_URL = 'https://tvok.netlify.app/api/'

axios.defaults.withCredentials = true

const api = axios.create({
    baseURL: API_URL
})

export default api